module.exports = __webpack_public_path__ + "static/img/004_TO8_1464.e43e4cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/004_TO8_1464.jpg
// module id = QxSN
// module chunks = 0